import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlogs } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

export default function Blogs() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchBlogs().then(setItems).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  const [hero, ...rest] = items;

  return (
    <section
      id="journal"
      data-testid="journal-section"
      className="py-24 lg:py-36 bg-[#f5f0e8] border-t border-[#1c1c1c]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between mb-16 gap-8">
          <SectionHeading
            title={<>Editorial dispatches<br />from the <em className="not-italic text-[#3d2b1f]">prime city</em>.</>}
            subtitle="The Journal · Premium Projects"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Link
            to={`/journal/${hero.slug}`}
            data-testid={`journal-hero-${hero.slug}`}
            className="lg:col-span-7 group block"
          >
            <div className="img-zoom aspect-[5/4] mb-8">
              <img src={hero.cover_image} alt={hero.title} className="w-full h-full object-cover" />
            </div>
            <div className="underline-label mb-4">{hero.category} · {hero.read_minutes} min read</div>
            <h3 className="font-display text-3xl lg:text-5xl text-[#1c1c1c] group-hover:text-[#3d2b1f] transition-colors leading-tight">
              {hero.title}
            </h3>
            <p className="mt-5 text-[#3d2b1f] text-base max-w-xl leading-relaxed">{hero.excerpt}</p>
            <div className="mt-6 flex items-center gap-2 text-[11px] uppercase tracking-[0.32em] text-[#c5a059]">
              Read dispatch <ArrowUpRight size={14} />
            </div>
          </Link>

          <div className="lg:col-span-5 flex flex-col gap-12">
            {rest.slice(0, 3).map((b, i) => (
              <Link
                key={b.id}
                to={`/journal/${b.slug}`}
                data-testid={`journal-card-${b.slug}`}
                className="group grid grid-cols-12 gap-5 items-start pb-10 border-b border-[#1c1c1c]/10 last:border-0"
              >
                <div className="col-span-4 img-zoom aspect-[4/5]">
                  <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" />
                </div>
                <div className="col-span-8">
                  <div className="underline-label mb-2 text-[10px]">{b.category}</div>
                  <h4 className="font-display text-xl lg:text-2xl text-[#1c1c1c] group-hover:text-[#3d2b1f] transition-colors leading-snug">
                    {b.title}
                  </h4>
                  <p className="mt-3 text-[#3d2b1f] text-sm line-clamp-2 leading-relaxed">{b.excerpt}</p>
                  <div className="mt-3 text-[10px] uppercase tracking-[0.32em] text-[#3d2b1f]">
                    {b.read_minutes} min · 0{i + 2}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
